export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives2.4a2aaec0.jpg";